import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table, Tag, Space, Button, Input, Tooltip, Image } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  DEFAULT_COMPANY_LOGO,
  ENTERPRISE_ROLE,
  IMAGE_HOST,
  INVESTOR_LOGO_HOST,
  LOGO_DEV_PUBLIC_KEY,
} from "../../../../../constant";
import { useSelector } from "react-redux";
import { replaceValueInDataSet } from "../../../../../utils";
import DeleteModal from "./delete";
import { toast } from "react-toastify";

const { TextArea } = Input;

const InvestorDetailCol = ({ data }) => {
  return (
    <div className="space-align-block">
      <Space align="center">
        <Image
          src={INVESTOR_LOGO_HOST + data.url + `?token=${LOGO_DEV_PUBLIC_KEY}`}
          fallback={IMAGE_HOST + DEFAULT_COMPANY_LOGO}
          preview={false}
          alt={data.name}
          style={{
            width: 28,
            maxHeight: 28,
          }}
        />
        <span className="mock-block">{data.lead_name}</span>
      </Space>
    </div>
  );
};

const LeadsList = ({
  company,
  page,
  setPage,
  total,
  companies,
  onReload,
  deleteHandler,
}) => {
  const { http } = global.services;
  const user = useSelector((state) => state.UserReducer.profile);
  const isEnterpriseUser = user?.role === ENTERPRISE_ROLE;

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [deletePreview, setdeletePreview] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [state, setState] = useState({
    editable: false,
    reasoning: null,
    notes: null,
    record: {},
  });

  const change = (r, e, field) => {
    const value = e.target.value;
    setState({
      ...state,
      editable: Boolean(value),
      [field]: value,
      record: r,
    });
  };

  const onUpdate = async () => {
    let params = { ...state.record };
    params["user_notes"] = state.notes;
    params["recommended_lead_notes"] = {
      reasoning: state.reasoning,
    };
    params["user_company_id"] = company.id;

    http
      .put("user-lead", params)
      .then(() => {
        toast.success("Notes updated successfully");
        setState({
          ...state,
          editable: false,
        });
        onReload();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error ?? "Failed to update notes");
      });
  };

  const deleteLeadHandler = (record) => {
    setSelectedData(record);
    setdeletePreview(true);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "",
      key: "lead_name",
      render: (data) => (
        <div className="space-align-container">
          <InvestorDetailCol data={data} />
        </div>
      ),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      render: (state) => replaceValueInDataSet(state),
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      render: (country) => replaceValueInDataSet(country),
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (status) => {
        let color = null;
        if (status.toLowerCase() === "new lead") color = "#D0BBFE";
        else if (status.toLowerCase() === "communicating") color = "#5B93FF";
        else if (status.toLowerCase() === "contacted") color = "#DD97E9";
        return status ? (
          <Tag color={color} key={status}>
            {status.toUpperCase() || ``}
          </Tag>
        ) : null;
      },
    },
    Table.EXPAND_COLUMN,
    {
      title: "Actions",
      key: "action",
      render: (text, record) => (
        <Space size="small">
          <Tooltip title="Edit">
            <Link to={`/leads-manager/edit/${record.id}`}>
              <Button
                type="primary"
                shape="circle"
                icon={<EditOutlined />}
                size={"medium"}
              />
            </Link>
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="danger"
              shape="circle"
              onClick={() => deleteLeadHandler(record)}
              icon={<DeleteOutlined />}
              size={"medium"}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const noDataBox = () => (
    <div className="no-data-wrapper">
      <svg
        width="116"
        height="155"
        viewBox="0 0 116 155"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M84.3395 107.067C77.1473 99.8745 67.3926 95.834 57.2213 95.834C47.05 95.834 38.6101 98.5597 31.4179 105.752"
          stroke="#d0bbfe"
        />
        <circle cx="36.0538" cy="83.8835" r="6.21686" fill="#d0bbfe" stroke="#d0bbfe" />
        <circle cx="79.6925" cy="83.8835" r="6.21686" fill="#d0bbfe" stroke="#d0bbfe" />
        <path
          d="M113.286 32.0038L113.286 32.0039C114.549 33.2661 115.25 34.9775 115.25 36.7446V38.0833H77.6667V0.5H79.0054C80.8037 0.5 82.5146 1.20212 83.776 2.4634C83.7761 2.46346 83.7761 2.46352 83.7762 2.46358L113.286 32.0038ZM67.0208 0.5V40.9948C67.0208 45.2498 70.5002 48.7292 74.7552 48.7292H115.25V147.099C115.25 150.832 112.249 153.833 108.516 153.833H7.23438C3.50147 153.833 0.5 150.832 0.5 147.099V7.23438C0.5 3.50147 3.50147 0.5 7.23438 0.5H67.0208Z"
          stroke="#d0bbfe"
        />
      </svg>
      <h4>No Data Found</h4>
    </div>
  );

  const paginatonItemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <a>
          <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 6.75C15.4142 6.75 15.75 6.41421 15.75 6C15.75 5.58579 15.4142 5.25 15 5.25V6.75ZM0.46967 5.46967C0.176777 5.76256 0.176777 6.23744 0.46967 6.53033L5.24264 11.3033C5.53553 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.59619 1.46447 6.59619 0.989593 6.3033 0.696699C6.01041 0.403806 5.53553 0.403806 5.24264 0.696699L0.46967 5.46967ZM15 5.25L1 5.25V6.75L15 6.75V5.25Z"
              fill="#262626"
            />
          </svg>
        </a>
      );
    }
    if (type === "next") {
      return (
        <a>
          <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 6.75C0.585786 6.75 0.25 6.41421 0.25 6C0.25 5.58579 0.585786 5.25 1 5.25L1 6.75ZM15.5303 5.46967C15.8232 5.76256 15.8232 6.23744 15.5303 6.53033L10.7574 11.3033C10.4645 11.5962 9.98959 11.5962 9.6967 11.3033C9.40381 11.0104 9.40381 10.5355 9.6967 10.2426L13.9393 6L9.6967 1.75736C9.40381 1.46447 9.40381 0.989593 9.6967 0.696699C9.98959 0.403806 10.4645 0.403806 10.7574 0.696699L15.5303 5.46967ZM1 5.25L15 5.25V6.75L1 6.75L1 5.25Z"
              fill="#262626"
            />
          </svg>
        </a>
      );
    }
    return originalElement;
  };

  return (
    <div className="data-table">
      <Table
        size={"middle"}
        className="leads-tbl"
        columns={columns}
        dataSource={companies}
        locale={{
          emptyText: noDataBox(),
        }}
        pagination={{
          current: page,
          pageSize: 5,
          position: ["bottomCenter"],
          itemRender: paginatonItemRender,
          showSizeChanger: false,
          total: total,
          onChange: (page) => {
            setPage(page);
          },
        }}
        expandable={{
          expandedRowRender: (record) => (
            <div className="flex">
              <div className="flex-1"></div>
              <div className="custom-notes">
                <div className="custom-notes-content">
                  <p>Reasoning:</p>
                  {state.record.id === record.id ? (
                    <>
                      <div className="flex">
                        <TextArea
                          style={{ margin: 0, borderWidth: 0 }}
                          value={state.reasoning}
                          onChange={(e) => change(record, e, "reasoning")}
                        ></TextArea>
                      </div>
                    </>
                  ) : (
                    <div className="flex">
                      <TextArea
                        style={{ margin: 0, borderWidth: 0 }}
                        value={record.recommended_lead_notes?.reasoning}
                        onChange={(e) => change(record, e, "reasoning")}
                      ></TextArea>
                    </div>
                  )}
                </div>
              </div>
              <div className="custom-notes">
                <div className="custom-notes-content">
                  <p>Custom note:</p>
                  {state.record.id == record.id ? (
                    <>
                      <div className="flex">
                        <TextArea
                          style={{ margin: 0, borderWidth: 0 }}
                          value={state.notes}
                          onChange={(e) => change(record, e, "notes")}
                        ></TextArea>
                      </div>
                      {state.editable && (
                        <div className="flex" style={{ justifyContent: "flex-end" }}>
                          <Button type="link" onClick={onUpdate}>
                            Save
                          </Button>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="flex">
                      <TextArea
                        style={{ margin: 0, borderWidth: 0 }}
                        value={record.user_notes}
                        onChange={(e) => change(record, e, "notes")}
                      ></TextArea>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ),
        }}
        expandIcon={({ expanded, onExpand, record }) => (
          <Button type="link" onClick={(e) => onExpand(record, e)}>
            View Notes
          </Button>
        )}
        expandedRowKeys={expandedRowKeys}
        onExpand={(expanded, record) => {
          var keys = [];
          if (expanded) {
            keys.push(record.id);
          }
          setState({
            ...state,
            editable: false,
            notes: record.user_notes,
            reasoning: record.recommended_lead_notes?.reasoning,
            record,
          });
          setExpandedRowKeys(keys);
        }}
      />
      <DeleteModal
        preview={deletePreview}
        previewHandler={() => setdeletePreview(false)}
        data={selectedData}
        onSuccess={deleteHandler}
      />
    </div>
  );
};

export default LeadsList;
